<!-- 产业服务-仓库供应 -->
<template>
<div class="info-block">
  <router-link :to="'/cyfw/ccwL/ckDetail/'+info.id" class="info-block-a"  v-bind:style="{backgroundImage:'url('+info.cover_img+')'}">
    <div class="div-1">
      <div class="div-1-1">{{info.name}}</div>
      <div class="div-1-2">{{info.area.substring(0,20)}}</div>
      <div class="div-1-3">{{info.intro.substring(0,55)}}</div>
      <div class="div-1-4">
        <table class="div-1-4-table" cellpadding="2" cellspacing="0" >
          <tr>
            <td class="td-title">可租面积(m²)</td>
            <td class="td-value">{{info.able_area}}</td>
            <td class="td-title">起租面积(m²)</td>
            <td class="td-value">{{info.start_area}}</td>
          </tr>
        </table>
      </div>
      <div class="div-3">
        <a class="td-action-1">我要看仓</a>
      </div>
    </div>


  </router-link>
</div>
</template>

<script>
export default {
  name: 'CyfwInfo1',
  props: {
    info: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {

    }
  },
  created:function(){

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info-block .info-block-a{
  display: block;
  position:relative;
  box-sizing:content-box;
  height:140px;
  padding:0px;
  margin:0px 1px 20px 0px;
  //background-color: #F6F8F9;
  border:1px solid #fff;
  background-size: 220px auto;
  background-repeat: no-repeat;
  background-position: 0px 0px;
  //box-shadow: #bbb 0px 0px 10px;
}

.info-block .info-block-a:hover{
  border:1px solid var(--color6);
  box-shadow:0px 0px 1px 0px #eee;
}

.div-1{
  position:relative;
  height:100%;
  width:100%;
  padding:0px 0px 0px 250px;
  //background:#fff;

}

.div-1-1{
  position:relative;
  height:30px;
  //background:red;
  font-size:14px;
  font-weight:600;
  text-align:left;
  line-height:26px;
  color:#000;
  padding:2px 10px 2px 0px;
}
.div-1-2{
  position:relative;
  height:30px;
  line-height:30px;
  text-align:left;
  color:#888;
  padding:0px 150px 0px 0px;
}

.div-1-3{
  position:relative;
  height:40px;
  line-height:20px;
  text-align:left;
  color:#515151;
  padding:0px 150px 0px 0px;
}

.div-1-4{
  position:relative;
  height:60px;
  //background:green;
  text-align:left;
  color:#888;
  padding:10px 150px 10px 0px;
}

.div-1-4-table{
  width:100%;
}

.div-1-4-table .td-title{
  text-align:left;
  width:120px;
  color:#888;
  padding-left:0px;
}

.div-1-4-table .td-value{
  text-align:left;
  width:100px;
  font-size:14px;
  font-weight:600;
  line-height:30px;
  color:var(--color6);
}


.div-3{
  position:absolute;
  top:0px;
  right:0px;
  width:100px;
  margin:15px 20px 15px 0px;
  padding-left:10px;
  //background:yellow;
}

.div-3 .td-action-1{
  display:block;
  height:30px;
  width:100px;
  padding:5px 15px 5px 15px;
  margin-top:40px;
  border:1px solid var(--color7);
  color:#000;
  line-height:20px;
  text-align:center;
}

.div-3 .td-action-1:hover{
  color:#fff;
  background:var(--color7);
  border:1px solid var(--color7);
}


.info-block .cell-base-info{
  position:relative;
  height:70px;
  color:#000;
  background-color:#fff;
  padding-right:0px;
}

.cell-base-info .base-info-title{
  float:left;
  height:30px;
  margin-right:75px;
  font-size:14px;
  font-weight:600;
  line-height:30px;
}

.cell-base-info .base-info-label{
  float:left;
  height:40px;
  margin-right:75px;
  font-size:14px;
  line-height:20px;
}

.cell-base-info .base-info-image{
  position:absolute;
  top:0px;
  right:0px;
  height:70px;
  width:70px;
  color:#000;
  border-radius:10px;
  background-color:#eee;
  padding-right:70px;
  background-size: 70px auto;
  background-repeat: no-repeat;
  background-position: right top;
}

.list-container-cell .cell-col-info{
  height:70px;
  padding-top:10px;
  background-color: #fff;
}

</style>



// WEBPACK FOOTER //
// src/components/module/CyfwInfo1.vue